import type NativeArray from '@ember/array/-private/native-array';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import type SkinnyLocationModel from 'garaje/models/skinny-location';
import type GlobalOverviewAccessService from 'garaje/services/global-overview-access';
import type SkinnyLocationsService from 'garaje/services/skinny-locations';
import throwUnlessTaskDidCancel from 'garaje/utils/throw-unless-task-did-cancel';

export default class LocationOverviewGlobalDevicesRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare skinnyLocations: SkinnyLocationsService;
  @service declare router: RouterService;
  @service declare globalOverviewAccess: GlobalOverviewAccessService;

  beforeModel(): void {
    if (!this.globalOverviewAccess.canVisitDevicesOrPrinters) {
      void this.router.transitionTo('unauthorized');
    }
  }

  model(): Promise<void | undefined | NativeArray<SkinnyLocationModel>> {
    return this.skinnyLocations.loadAllTask.perform().catch(throwUnlessTaskDidCancel);
  }
}
